import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import {getDocumentTemplate} from '../Property_Api'
import {CircularProgress} from '@mui/material'
import { agreementListDataType, propertyCreateAgreementPropsDataType } from '../PropertyDataTypes'

const PropertyCreateAgreement = ({propertyDetails, id, get_view_property}: propertyCreateAgreementPropsDataType) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(true)
  const [agreementList, setAgreementList] = useState<agreementListDataType[]>()

  // route to create agreement with all the property details
  const routeToCreateAgreement = () => {
    navigate('/create_agreement', {
      state: {
        propertyDetails: propertyDetails,
      },
    })
  }

  // function to get agreement list
  const getAgreementList = async () => {
    if (id) {
      setLoading(true)
      try {
        const {data: response} = await getDocumentTemplate(id)
        if (response.code === '200') {
          setAgreementList(response.data)
        } else if (response.code === '500') {
          setAgreementList(response.data)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      } finally {
        setLoading(false)
      }
    }
  }

  // onload frtch the list of agreements
  useEffect(() => {
    getAgreementList()
  }, [])
  return (
    <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        <div className='card mb-6 mb-xl-10'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            {/* Begin: Heading agreement */}
            <div className='card-title m-0'>
              <h3 className='fw-bold m-0'>Agreement</h3>
            </div>
            {/* End: Heading agreement */}
            <div className='d-flex flex-column pt-3'>
              {/* Begin: create agreement button */}
              <button
                onClick={routeToCreateAgreement}
                className='align-self-center btn btn-sm btn-primary me-3'
              >
                Create agreement
              </button>
              {/* End: create agreement button */}
            </div>
          </div>

          {agreementList?.length === 0 ? (
            // Begin: Section when no agreements present
            <div className='d-flex flex-column align-items-center flex-start p-8'>
              <img
                src='/media/svg/no-data-found/no-data-found.svg'
                alt='No document uploaded'
                className='h-200px w-200px'
              />
              <span className='fw-bold text-muted fs-1 text-center'>No agreement present</span>
            </div>
          ) : (
            // End: Section when no agreements present
            <div className='d-flex flex-wrap g-3 g-xl-5 mb-1 mb-xl-3 mt-8'>
              <div className='card w-100'>
                {/* Begin: Table */}
                <div id='table div'>
                  <div className='card mb-5'>
                    <div className='card-body py-3'>
                      <div className='table-responsive'>
                        {/* begin::Table */}
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                          {/* begin::Table head */}
                          <thead>
                            <tr className='fw-bold text-muted'>
                              <th className='max-w-150px ms-10 ps-5'>Document Label</th>
                              <th className='max-w-200px'>Document type</th>
                              <th className='max-w-100px'>Document status</th>
                              <th className='max-w-100px'>Actions</th>
                            </tr>
                          </thead>
                          {/* end::Table head */}
                          {/* begin::Table body */}
                          <tbody>
                            {agreementList &&
                              agreementList.map((agreement, index: number) => {
                                return (
                                  <tr key={index}>
                                    <td className='max-w-150px'>
                                      <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-45px me-3'>
                                          <span className='symbol symbol-50px me-2'></span>
                                        </div>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <Link
                                            to={agreement.document_path}
                                            target='_blank'
                                            className='text-dark fw-bold text-hover-primary fs-6'
                                            title={
                                              agreement.document_label.charAt(0).toUpperCase() +
                                              agreement.document_label.slice(1)
                                            }
                                          >
                                            <div className='text-truncate max-w-150px'>
                                              {agreement.document_label.charAt(0).toUpperCase() +
                                                agreement.document_label.slice(1)}
                                            </div>
                                          </Link>
                                        </div>
                                      </div>
                                    </td>
                                    <td className='max-w-200px'>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {agreement.property_document_type_name
                                          .charAt(0)
                                          .toUpperCase() +
                                          agreement.property_document_type_name.slice(1)}
                                      </span>
                                    </td>
                                    <td className='max-w-100px'>
                                      <span
                                        className={`badge ${
                                          agreement.property_document_status === 'Signed'
                                            ? 'badge-light-success'
                                            : 'badge-light-warning'
                                        }`}
                                      >
                                        {agreement.property_document_status}
                                      </span>
                                    </td>

                                    <td className='max-w-100px'>
                                      <div className='d-flex flex-shrink-0'>
                                        {agreement.document_path && (
                                          <Link
                                            to={agreement.document_path}
                                            target='_blank'
                                            className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            title='View agreement'
                                          >
                                            <i className='bi bi-eye-fill bi-4x fs-2'></i>
                                          </Link>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })}
                          </tbody>
                          {/* end::Table body */}
                        </table>
                        {/* end::Table */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* End: Table */}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default PropertyCreateAgreement
